/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
/* istanbul ignore file */

/* =========================
   Navigation Routes
========================= */

export const ROUTES = {
  MANUAL_REVIEW: '/manualreview',
  ON_HOLD: '/onhold',
  FUZZY_VRM: '/fuzzyvrm',
  MANUAL_REVIEW_PAGE: '/manualreviewpage',
  DISCARDED_CASES: '/discardedcases',
}

export const TASK_STATUS = {
  ACTIVE: 'Active',
  HOLD: 'Hold',
  ON_HOLD_LABEL: 'On Hold',
  DISCARDED: 'Discarded',
  ISSUED: 'Issued',
  HOLD_LOWER: 'hold',
  DISCARDED_LOWER: 'discarded',
}

/* =========================
   Field IDs & Props
========================= */

export const FIELD_IDS = {
  vrm: {
    id: 'txt_vrm',
    name: 'txt_vrm',
    dataTestId: 'txt_vrm',
  },
  dvla: {
    make: {
      id: 'txt_make',
      name: 'txt_make',
      dataTestId: 'txt_make',
    },
    model: {
      id: 'txt_model',
      name: 'txt_model',
      dataTestId: 'txt_model',
    },
    color: {
      id: 'txt_color',
      name: 'txt_color',
      dataTestId: 'txt_color',
    },
  },
  offenceDetails: {
    referenceId: {
      id: 'txt_referenceId',
      name: 'txt_referenceId',
      dataTestId: 'txt_referenceId',
    },
    streetId: {
      id: 'txt_streetId',
      name: 'txt_streetId',
      dataTestId: 'txt_streetId',
    },
    contraventionLocation: {
      id: 'txt_contraventionLocation',
      name: 'txt_contraventionLocation',
      dataTestId: 'txt_contraventionLocation',
    },
    contraventionCode: {
      id: 'txt_contraventionCode',
      name: 'txt_contraventionCode',
      dataTestId: 'txt_contraventionCode',
    },
  },
}

/* =========================
   Field Labels
========================= */

export const LABELS = {
  dvla: {
    make: 'Make',
    category: 'Category',
    color: 'Color',
  },
  offenceDetails: {
    referenceId: 'Pre-Case ID',
    siteName: 'Site Name',
    contraventionLocation: 'Contravention Location',
    contraventionCode: 'Contravention Code',
    contraventionNote: 'Contravention Notes',
  },
  stayedDetails: {
    allowedStayDuration: 'Allowed Stay',
    actualStayDuration: 'Actual Stay',
    overStayDuration: 'Over Stay',
  },
}

/* =========================
   Messages
========================= */

export const MESSAGES = {
  vrm: {
    updateSuccess:
      'VRM updated successfully. The case has been resubmitted for session validation and will be available within 30 minutes if valid',
    updateFailed: 'Failed to update VRM',
    updateError: 'Error updating VRM',
    confirmUpdate: 'Are you sure want to update this VRM?',
  },
  holdReview: {
    success: 'Case updated as OnHold Successfully!',
    confirm: 'Are you sure you want to hold this task?',
    error: 'Error holding review. Please try again.',
    failed: 'Failed to hold review.',
    invalidObservation:
      'Unable to identify observation. Please refresh and try again.',
  },
  proceed: {
    success: 'Notice has been created successfully',
    failed: 'Failed to create notice.',
    error: 'Error creating notice. Please try again.',
  },
  discard: {
    success: 'Review Discarded Successfully',
    failed: 'Failed to discard review.',
    error: 'Error discarding review. Please try again.',
  },
}

/* =========================
   Page Configuration
========================= */

export const PAGE_CONFIG = {
  manualReviewDetail: {
    pageTitleTemplate: 'Pre-case ID   __caseNumber__',
    fields: {
      caseNumber: 'id',
      status: 'taskStatus',
    },
    holdAction: {
      label: 'Hold Review',
      icon: 'holdReview.svg',
    },
  },
}

/* =========================
   Popup Configurations
========================= */

export const DISCARD_POPUP_CONFIG = {
  dialogId: 'discardReasonDialog',
  dialogClass: 'discard-reason-dialog',
  containerClass: 'discard-reason-container',
  title: 'Discard Reason',
  autoCompleteField: {
    id: 'discardReasonAutocomplete',
    dataTestId: 'discardReasonAutocomplete',
    fieldLabel: '',
    fieldValue: 'discardReason',
    placeholder: 'Select a reason',
    valueField: 'id',
    textField: 'discardReason',
    className: 'colWiseControl',
    isSelect: false,
    disabled: false,
  },
  buttons: {
    cancel: {
      label: 'Cancel',
      variant: 'secondary',
      dataTestId: 'discard_reason_cancel',
      className: 'cancel-button',
    },
    save: {
      label: 'Save',
      variant: 'primary',
      dataTestId: 'discard_reason_save',
      className: 'save-button',
    },
  },
}

/* =========================
   Button Configurations
========================= */

export const BUTTON_CONFIGS = {
  reviewFooter: {
    DISCARD: {
      fieldValue: 'Discard',
      fieldLabel: 'Discard',
      id: 'btn_discard',
      dataTestId: 'btn_discard',
      className: 'discardButton',
      variant: 'secondary',
    },
    PROCEED: {
      fieldValue: 'Proceed',
      fieldLabel: 'Create Notice',
      id: 'btn_proceed',
      dataTestId: 'btn_proceed',
      className: 'proceedButton',
      variant: 'primary',
    },
  },
}

/* =========================
contravention snapshot related constants
========================= */
export const CONTRAVENTION_SNAPSHOT_CONSTANTS = {
  TITLE: 'Contravention Review',
  VEHICLE_DIRECTION: {
    ENTRY: 'APPROACHING',
    EXIT: 'LEAVING',
  },

  IMAGE_TYPE: {
    ENTRY: 'entry',
    EXIT: 'exit',
  },
}
